import { render, staticRenderFns } from "./number-x-keyboard-temp.vue?vue&type=template&id=2c36edf6&scoped=true&"
import script from "./number-x-keyboard-temp.vue?vue&type=script&lang=js&"
export * from "./number-x-keyboard-temp.vue?vue&type=script&lang=js&"
import style0 from "./number-x-keyboard-temp.vue?vue&type=style&index=0&id=2c36edf6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c36edf6",
  null
  
)

export default component.exports